import "./contentpage.scss";
import { Fragment, h } from "preact";
import { useEffect, useMemo } from "preact/hooks";
import { route, RouterProps } from "preact-router";
import { Container, FormField, Button } from "uitoolkit";
import { DataTableTyped, TypedTableColummn, type TypedTableConfig, useTypedTableConfiguration } from "components/table";
import { ContentItem, ContentItemType } from "../../graphql/types";
import { formatDateTime } from "services/utils";
import { useBodyStyle, usePageTitle } from "hooks";
import { Sidebar } from "components/sidebar";
import { ensureGlobalUserDataItems, globalUserData } from "../../state/userdata";

const getColumnId = (item: ContentItem) => item.id ?? "";

const defaultConfig: TypedTableConfig = { sortColumn: "Created", sortOrder: "descending" };

export function ConversationsPage(props: {} & RouterProps) {
    useBodyStyle("contentpage")
    usePageTitle("Content");

    useEffect(() => { ensureGlobalUserDataItems(); }, []);

    const items = globalUserData.value.allItems;

    const allColumns = useMemo<TypedTableColummn<ContentItem>[]>(() => [
        {
            name: "★",
            getter: (item: ContentItem) => item.starred ? "★" : "",
            getSortingKey: (item: ContentItem) => item.starred ? "a" : "b"
        },
        {
            name: "Title",
            getter: (item: ContentItem) => item.title || "untitled",
            getSortingKey: (item: ContentItem) => item.title || "untitled",
        },
        {
            name: "Type",
            getter: (item: ContentItem) => item.type,
            getSortingKey: (item: ContentItem) => ""+item.type
        },
        {
            name: "Created",
            getter: (item: ContentItem) => formatDateTime(item.created),
            getSortingKey: (item: ContentItem) => item.created
        },
    ], []);
    const { visibleData, visibleColumns, sortColumn, sortOrder, onColumnClicked, onColumnVisibilityChanged, filter, onFilterChanged } = useTypedTableConfiguration(items ?? [], allColumns, undefined, undefined, defaultConfig);

    return (
        <Container class="row grow maxheight-100vh overflow-y-hidden">
            <Sidebar page="list" />
            <Container class="flex-column overflow-y-auto grow scrollbar-gutter-stable">
                <Container class="p-4 pt-0 bg-primary gap-16 flex-column grow maxwidth">
                    <div style={{ paddingTop: "16px" }}>
                        <h2>Content</h2>
                    </div>
                    {
                        //conversations?.result?.conversations.map(item => <p><Link href={"/chat/" + item.id}>{item.subject}</Link></p>)
                    }
                    {
                        items && items.length == 0 &&
                        <Fragment>
                            <Button variant="default" onClick={() => route("/chat")}>Start a new conversation</Button>
                        </Fragment>
                    }
                    {
                        ((items?.length ?? 0) > 0) &&
                        <Fragment>
                            <Container class="component-form noprint">
                                <FormField id="filter" label="" placeholder="Filter" type="text" value={filter} onChange={e => onFilterChanged(e.currentTarget.value)} />
                            </Container>
                            <DataTableTyped
                                showHeader
                                className="content"
                                columns={visibleColumns}
                                items={visibleData || []}
                                sortColumn={sortColumn?.name}
                                sortOrder={sortOrder}
                                onColumnClicked={onColumnClicked}
                                getItemKey={getColumnId}
                                onItemClicked={(item) => route((item.type == ContentItemType.Document ? "/note/" : "/chat/") + item.id!)}
                            />
                        </Fragment>
                    }
                </Container>
            </Container>
        </Container>
    );
}
